import { useTranslation } from 'react-i18next';
import type { ITask } from '@interfaces/ISubcontractorPortal';
import { formatShortDate } from '../subcontractors.format';
import styles from './TasksList.module.css';

export function TasksList({ tasks, tz }: { tasks: ITask[]; tz: string }) {
  const { t } = useTranslation();
  return (
    <section className={styles.panel}>
      <header className={styles.head}>
        <div className={styles.headLeft}>
          <h3 className={styles.title}>{t('subcontractors.tasks.title')}</h3>
          <p className={styles.subtitle}>{t('subcontractors.tasks.subtitle')}</p>
        </div>
        <span className={styles.count}>
          {t('subcontractors.tasks.count', { count: tasks.length })}
        </span>
      </header>
      <ul className={styles.list}>
        {tasks.map((task) => (
          <li key={task.id} className={styles.row} data-status={task.status}>
            <span className={styles.marker} aria-hidden="true" />
            <div className={styles.main}>
              <span className={styles.taskTitle}>{task.title}</span>
              <span className={styles.taskMeta}>
                {formatShortDate(task.date, tz)}
                {task.timeWindow ? ` · ${task.timeWindow}` : ''}
                {task.location ? ` · ${task.location}` : ''}
              </span>
            </div>
            <span className={styles.statusPill} data-status={task.status}>
              {t(`subcontractors.taskStatus.${task.status}`)}
            </span>
          </li>
        ))}
      </ul>
    </section>
  );
}
